import React from "react";
import { Tabs, Tab, Box, Badge } from "@mui/material";
import { makeStyles } from "@mui/styles";
import { useTheme } from "@mui/styles";
import { FormattedMessage } from "react-intl";
import useMediaQuery from "@mui/material/useMediaQuery";
import Icon1 from "../../../../../../app/assets/images/icons/Group 1.svg";
import Icon2 from "../../../../../../app/assets/images/icons/smile_square.svg";
import Icon3 from "../../../../../../app/assets/images/icons/list.svg";
import Icon4 from "../../../../../../app/assets/images/icons/list (1).svg";
import BubbleIcon from "../../../../../../app/assets/images/icons/Bubble.svg";

const RecruiterTab = ({ selectedRecruiterTab, setSelectedRecruiterTab, messagesUnreadCount = 0 }) => {
  const theme = useTheme();
  const isDesktop = useMediaQuery(theme.breakpoints.up("md"));
  const isMobile = useMediaQuery("(max-width:600px)");

  const tabs = [
    {
      labelId: "menu.dashboard",
      icon: <img src={Icon1} alt="Dashboard" style={{ width: 24, height: 24 }} />,
    },
    {
      labelId: "menu.applications",
      icon: <img src={Icon2} alt="Applications" style={{ width: 24, height: 24 }} />,
    },
    {
      labelId: "menu.jobs",
      icon: <img src={Icon3} alt="Jobs" style={{ width: 24, height: 24 }} />,
    },
    {
      labelId: "nav.recruiter.cv_theque",
      icon: <img src={Icon4} alt="CV Theque" style={{ width: 24, height: 24 }} />,
    },
    {
      labelId: "menu.messages",
      icon: (
        <Badge
          badgeContent={messagesUnreadCount}
          invisible={!messagesUnreadCount}
          sx={{
            "& .MuiBadge-badge": {
              backgroundColor: "#D9F752",
              color: "#023331",
              fontWeight: 700,
            },
          }}
        >
          <img src={BubbleIcon} alt="Messages" style={{ width: 24, height: 24 }} />
        </Badge>
      ),
    },
  ];

  const tabSx = {
    fontSize: "1rem",
    textTransform: "none",
    color: "#234545",
    fontFamily: "Segoe UI Semibold, sans-serif",
    marginRight: isDesktop ? "48px" : "0px",
    minWidth: isDesktop ? "auto" : "40px",
    "&.Mui-selected": {
      color: "#234545",
    },
    "&:last-of-type": {
      marginRight: 0,
    },
  };

  const useStyles = makeStyles(() => ({
    tabs: {
      overflowX: isDesktop ? "visible" : "auto",
      borderRadius: isDesktop ? "0" : "12px",
      padding: isDesktop ? "0 56px" : "0 16px",
      overflowY: "hidden",
      "& .MuiTabs-indicator": {
        backgroundColor: `${theme.palette.text.main} !important`,
      },
      "&.MuiTabs-scroller": {
        overflowY: "hidden",
      }
    },
    tab: {
      fontWeight: theme.typography.body1bold.fontWeight,
      fontSize: theme.typography.body1bold.fontSize,
      color: `${theme.palette.text.main} !important`,
      "&.Mui-selected": {
        color: `${theme.palette.text.main} !important`,
      },
    },
  }));

  const classes = useStyles();

  const handleChange = (event, newValue) => {
    setSelectedRecruiterTab(newValue);
  };

  return(
    <>
      <Box sx={{width: "100%" }}>
        <Tabs 
          value={selectedRecruiterTab} 
          onChange={handleChange} 
          aria-label="recruiter navigation tabs"
          variant={isDesktop ? "fullWidth" : "scrollable"}
          sx={{ position: "relative", zIndex: 1 }}
          className={classes.tabs}
        >  
          {tabs.map((tab, idx) => (
            <Tab
              key={tab.label}
              icon={tab.icon}
              iconPosition="start"
              label={
                isMobile
                  ? selectedRecruiterTab === idx
                    ? <FormattedMessage id={tab.labelId} />
                    : null
                  : <FormattedMessage id={tab.labelId} />
              }
              sx={tabSx}
            />
          ))}
        </Tabs>
      </Box>
      <Box sx={{ position: "relative", bottom: 0, width: "100%", height: "2px", backgroundColor: theme.palette.background.neutral, zIndex: 0 }} />
    </>
  );
};

export default RecruiterTab;
